import { CommonModule } from '@angular/common';
import { Component, ViewChild, inject } from '@angular/core';
import { FormBuilder, FormControl, Validators } from '@angular/forms';
import { AddDestinationAlternateFormComponent } from '@components/add-destination-alternate-form/add-destination-alternate-form.component';
import { e2eLocators } from '@components/add-destination-alternate-form/add-destination-alternate-form.constants';
import { UntilDestroy } from '@ngneat/until-destroy';
import { I18NextPipe } from 'angular-i18next';
import { AlertComponent, ButtonComponent, FormsUtil, MbsPopupType, ModalComponent, ModalFooterDirective, ToastService } from 'mbs-ui-kit';
import { Destination, StorageAccountV2 } from 'mbs-ui-shared/src/lib/models/StorageAccount';
import { StorageDestinationsFacade } from 'mbs-ui-shared@facades/storage-destinations.facade';
import { StorageType } from 'mbs-ui-shared@models';
import { finalize } from 'rxjs/operators';

@UntilDestroy()
@Component({
  selector: 'mbs-add-ftp-root-folder-modal',
  templateUrl: './add-destination-alternate-modal.component.html',
  imports: [
    AddDestinationAlternateFormComponent,
    AlertComponent,
    ButtonComponent,
    CommonModule,
    ModalComponent,
    I18NextPipe,
    ModalFooterDirective
  ]
})
export class AddDestinationAlternateModalComponent {
  private fb = inject(FormBuilder);
  private destinationsFacade = inject(StorageDestinationsFacade);
  private i18N = inject(I18NextPipe);
  private toast = inject(ToastService);

  public readonly popupType = MbsPopupType;
  public readonly storageType = StorageType;

  public storageAccount: StorageAccountV2;
  public destination: Destination;
  public form = this.fb.group({
    displayBucketName: new FormControl('', [Validators.required]),
    bucketName: new FormControl('', [Validators.required]),
    companies: new FormControl([])
  });
  public errorText = null;
  public loading = false;
  public finalSuccessAction: () => void;

  @ViewChild(ModalComponent, { static: true }) modal: ModalComponent;

  private handleFinalSuccess() {
    this.toast.success(this.i18N.transform('shared:modals.addDestinationBucket.destinationSaved'));
    this.finalSuccessAction && this.finalSuccessAction();
  }

  onActionButtonClick() {
    if (!this.form.valid) {
      return void FormsUtil.triggerValidation(this.form);
    }

    this.loading = true;
    const { displayBucketName, bucketName, companies } = this.form.value;
    const data = {
      displayBucketName,
      bucket: {
        bucketName
      },
      assignToCompanies: companies.map((company) => company.id)
    };

    const query$ = this.destination
      ? this.destinationsFacade.editDestination({
          storageAccountId: this.storageAccount?.id,
          data,
          destinationId: this.destination?.id,
          skipError: true
        })
      : this.destinationsFacade.createDestination({
          storageAccountId: this.storageAccount?.id,
          data,
          skipError: true
        });

    query$.pipe(finalize(() => (this.loading = false))).subscribe({
      next: () => {
        this.handleFinalSuccess();
        this.modal.save();
      },
      error: (err) => (this.errorText = err?.error?.detail)
    });
  }

  protected readonly e2eLocators = e2eLocators;
}
